import React, { useEffect, useRef } from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import { Arrow } from "../../icons"

const StaffTestimonial = ({ items, title }) => {

  return (
    <section className="staff-testimonial">
      <div className="staff-testimonial__inner">
        <div className="staff-testimonial__wrapper">
          <div className="line line--vertical center-top"></div>
          <div className="line line--vertical center-bottom"></div>
          <div className="line line--horizon center-right"></div>

          <div className="staff-testimonial__title">
            {title && <h2 className="tagline">{parse(title)}</h2>}
            <div className="line line--horizon center-left"></div>
          </div>

          <div className="staff-testimonial__items">

            {items?.length > 0 && items?.map((el, i) => (
              <div key={i} className="staff-testimonial__item">
                {el.image && <Asset asset={el.image} />}
                {el.richQuote && <StructuredText data={el.richQuote} />}
                {el.name && <h3>Meet {el.name}</h3>}
                {el.jobTitle && <h3>{parse(el.jobTitle)}</h3>}
                {el.link?.length > 0 && (
                  <Link
                    to={el.link[0].link[0].externalLink ? el.link[0].link[0].externalLink : el.link[0].link[0].internalLink.permalink}>
                    <Arrow />
                  </Link>)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default StaffTestimonial

export const query = graphql`
 fragment StaffTestimonialProps on DatoCmsStaffTestimonial {
  ... on DatoCmsStaffTestimonial {
    id
    title
    items {
      jobTitle
      name
      richQuote {
        value
      }
      image {
        ...InternalAssetProps
      }
      link {
        ...LinkWithoutTitleProps
      }
    }
  }
}
`